// Prevent same-URL pushState calls from polluting the history stack.
// BigCommerce's theme bundle calls pushState when processing ?sku= query
// params on PDP pages, which creates duplicate history entries that break the
// browser back button.  Converting same-URL pushes to replaceState is a no-op
// from the user's perspective but keeps the history stack clean.
(function patchPushState() {
  const origPushState = history.pushState.bind(history);
  history.pushState = function patchedPushState(state: any, title: string, url?: string | URL | null) {
    if (url != null && new URL(String(url), location.href).href === location.href) {
      return history.replaceState(state, title, url);
    }
    return origPushState(state, title, url);
  };
})();

import { bindLinks, initApp, requestIdleCallbackFunction, unbindLinks } from './load-functions';

// check if the accesed url contains a hashtag
if (window.location.hash.startsWith('#/')) {
  initApp();
} else {
  // load the app when the browser is free
  requestIdleCallbackFunction(initApp);
  // and bind links to load the app
  bindLinks();
  window.addEventListener('beforeunload', unbindLinks);
  // and observe global flag to simulate click
  window.b2b.initializationEnvironment.isInitListener = () => {
    unbindLinks();
    setTimeout(() => window.b2b.initializationEnvironment.clickedLinkElement?.click(), 0);
  };
}
